import classNames from "classnames"

import { Subtitle, Title2 } from "@bounce/design-system"
import type { Nullable } from "@bounce/util"

import type { ItemProps } from "./Item"
import { Item } from "./Item"

export type IconListProps = {
  title?: Nullable<string>
  subtitle?: Nullable<string>
  items: ItemProps[]
  className?: string
  containerClassName?: string
}

export const IconList = ({ title, subtitle, items, containerClassName, className }: IconListProps) => (
  <section className={classNames("relative mx-auto flex w-full max-w-screen-xl flex-col px-6", className)}>
    <Title2 className="max-w-[600px] text-black">{title}</Title2>
    {!!subtitle && <Subtitle className="mt-2 max-w-4xl text-neutral-800 md:mt-2.5 xl:mt-3">{subtitle}</Subtitle>}
    <div
      className={classNames(
        "mt-14 flex flex-col gap-10 sm:grid sm:grid-cols-2 sm:gap-y-12 md:mt-16 lg:grid-cols-4",
        containerClassName,
      )}>
      {items.map((props, i) => (
        <Item key={i} {...props} />
      ))}
    </div>
  </section>
)
